// src/docs/api/groups/suprimentosEndpoints.ts
import type { ApiEndpoint } from "../apiDocsSchema";

export const coordenacaoEndpoints: ApiEndpoint[] = [
  {
    group: "Coordenação",
    name: "Lista de Produtos",
    method: "GET",
    path: "/departamentos/comercial/produtos-comercial",
    authRequired: true,
    usageDescription:
      "Essa API é utilizada em https://${seuDominio}.com/${departamentoAcessado}/produtos, sendo essencial para receber os dados de cada produto registrado para o respectivo departamento.",

    responseDetails:
      "Retorna a fonte podendo ser banco (referente ao banco de dados) ou cache, e em data é retornado a lista de produtos cadastrados e seus dados correspondentes.",
    description:
      "Retorna a lista de produtos pertencentes ao departamento de suprimentos.",
    developed: true,

    params: [
      {
        name: "Authorization (enviado no cabeçalho/header)",
        in: "header",
        type: "string",
        required: true,
        description: "Sua chave de acesso Acess Token.",
        example: "28271737183818371738192912838bcbchhdh377ycbd6v6d7v6d6v7v7d8v",
        source: "Definido pelo próprio usuário no momento do cadastro.",
      },
    ],
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,

          fonte: "banco",
          versao: 1,
          data: [
            {
              codigo: "PRDZ024",
              ncm: "84433240",
              nome: "FURUNO IC - 120",
              classificacao: "ESTOQUE",
              posicao: "H1",
              ocultar: true,
              departamento: "suprimentos",
              empresa_id: "1",
              custo_unitario: "2500.00",
              moeda: "USD",
            },
          ],
        },
      },
    ],
  },
];
